module.exports = __webpack_public_path__ + "static/media/avatar-07.a44b202f.svg";